import { render, staticRenderFns } from "./PhieuThuCoGamLayout.vue?vue&type=template&id=48d8d36f&"
import script from "./PhieuThuCoGamLayout.vue?vue&type=script&lang=js&"
export * from "./PhieuThuCoGamLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports